import React, { Component } from "react";
import { connect } from "react-redux";
import ActionSection from "./components/ActionSection";
import PreviewSection from "./components/PreviewSection";
import ShareSection from "./components/ShareSection";
import { SNAPUP_UPDATE, CUSTOM_LANUAGE, getSnapUpData } from "../../../../../../actions/appsMoreAction";
import { MediaBaseUrl, WASABI_PATH, SW_LOGO } from "../../../../../../actions/api";
import { getDefaultLogo } from "../../../../../../utils";
import { GET_SNAPUP_DETAILS } from "../../../../../../actions/addFeedActions";
import { getWidgetWallData } from "../../../../../../actions/wallDataAction";
import CommonUpgradePop from "../../../../../CommonComponents/UpgradePop";
import { togglePlanSection_D } from "../../../../../../actions/showDisplayModalAction";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import "./review-hub.css";

const placeholders = {
    title: 'Share you Experience',
    subTitle: 'Upload your post to get featured on Social Wall.',
    btnText: 'Submit Post',
    thankUMsg: 'Thanks for the submission',
}
class ReviewHub extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 2,
            title: "",
            subTitle: "",
            btnText: "",
            thankUMsg: "",
            logoImg: null,
            onsiteEnable: 0,
            moderation: 0,
            logoImgUploaded: false,
            loading: false,
            titleError: false,
            subTitleError: false,
            btnTextError: false,
            thankUMsgError: false,
            onsite_language: 'english',
            allLang: null,
            backgroundImg: null,
            showUpgradeModal: false,
            showDownloadModal: false,
            downloadLoading: false
        }
    }

    componentDidMount() {
        this.props.getWidgetData(localStorage.getItem('wallId'));
        this.props.GET_SNAPUP_DETAILS()
        this.setSnaup_data()
        CUSTOM_LANUAGE((data) => { this.setState({ allLang: data }) })
    }

    componentDidUpdate(previusProps) {
        const { snapUpData } = this.props
        if (previusProps.snapUpData !== snapUpData) {
            this.setSnaup_data()
        }
    }

    setSnaup_data = () => {
        const { snapUpData, userData } = this.props
        const logoImage = getDefaultLogo(snapUpData?.onsite_logo ? snapUpData?.onsite_logo : SW_LOGO);
        this.setState({
            tab: snapUpData?.choose_content_category || 1,
            title: snapUpData?.onsite_popup_title,
            subTitle: snapUpData?.onsite_popup_sub_heading,
            btnText: snapUpData?.onsite_popup_btn_txt,
            thankUMsg: snapUpData?.onsite_succ_msg,
            onsiteEnable: Number(snapUpData?.onsite_status),
            logoImg: logoImage,
            logoImgUploaded: logoImage != null ? !(logoImage.includes('/tagbox') || logoImage.includes('tagembed')) : false,
            onsite_language: snapUpData?.onsite_language,
            moderation: snapUpData?.onsite_moderation,
            backgroundImg: snapUpData?.onsite_background_image,
            showUpgradeModal: userData?.user?.onsite_status ? false : true
        });
    }

    onTextFieldChange = (e) => this.setState({ [e.target.name]: e.target.value, [`${e.target.name}Error`]: false })
    uploadImage = (path, type) => this.setState({ [type]: path != null ? path : type == "logoImg" ? getDefaultLogo(null) : "", [`${type}Uploaded`]: path != null })
    changeTab = (type) => this.setState({ tab: type });

    submitPost = () => {
        const { tab, title, subTitle, btnText, thankUMsg, logoImg, moderation, onsiteEnable, onsite_language, backgroundImg } = this.state;
        if (title && subTitle && btnText && thankUMsg) {
            const data = {
                choose_content_category: tab,
                onsite_popup_title: title,
                onsite_popup_sub_heading: subTitle,
                onsite_logo: logoImg && !['tagbox.svg', 'tagembed.svg'].some(item => logoImg.includes(item)) ? logoImg : "",//`${MediaBaseUrl}dashboard/tagbox-logo-dark.png`,
                onsite_popup_btn_txt: btnText,
                onsite_succ_msg: thankUMsg,
                onsite_status: onsiteEnable,
                onsite_moderation: moderation,
                wallId: localStorage.getItem('wallId'),
                onsite_language: onsite_language,
                onsite_background_image: backgroundImg,
                network: 29,
                filter: 10,
            }

            this.setState({ loading: true });
            this.props.SNAPUP_UPDATE(data, () => {
                this.setState({ loading: false })
                this.props.GET_SNAPUP_DETAILS()
            })
        }
        else {
            if (!title) this.setState({ titleError: true })
            if (!subTitle) this.setState({ subTitleError: true })
            if (!btnText) this.setState({ btnTextError: true })
            if (!thankUMsg) this.setState({ thankUMsgError: true })
        }
    }

    setOnsiteStatus = (e) => this.props.SNAPUP_UPDATE({ onsite_status: Number(e), wallId: localStorage.getItem('wallId'), network: 29, filter: 10, }, () => { })

    closeDownloadModal = () => this.setState({ showDownloadModal: false, downloadLoading: false })

    downloadSnapUpData = () => this.setState({ downloadLoading: true }, () => getSnapUpData(this.closeDownloadModal))

    render() {
        const { wallsData, closeReviewHub, appsMore, userData, pricingModal } = this.props;
        const { showDownloadModal, showUpgradeModal, downloadLoading } = this.state;

        return <div className="p-3 review-hub" id="snapupUpgradModal">
            <div className="d-flex flex-wrap">
                <div className="review-hub-left">
                    <ActionSection {...this.state} changeTab={this.changeTab} submitPost={this.submitPost} onTextFieldChange={this.onTextFieldChange} uploadImage={this.uploadImage} placeholders={placeholders} closeReviewHub={closeReviewHub} setOnsiteStatus={(e) => this.setState({ onsiteEnable: e }, () => this.setOnsiteStatus(e))} setLanguage={(e) => this.setState({ onsite_language: e })} />
                </div>
                <div className="review-hub-right">
                    <div className="ra-presha bg-white rounded-8 w-100 shadow">
                        <div className="row align-items-center">
                            <div className="col-xxl-7 col-12">
                                <PreviewSection {...this.state} placeholders={placeholders} />
                            </div>
                            <div className="col-xxl-5 col-12">
                                {userData?.user?.leaddataCollection ? <div className="d-flex align-items-center justify-content-end px-3 pt-3 pb-2 position-relative z-2">
                                    <button className="btn btn-primary" onClick={() => this.setState({ showDownloadModal: true })}>
                                        <FontAwesomeIcon type={'regular'} icon={'download'} iconClass={'me-2'} />
                                        Download Data
                                    </button>
                                </div> : null}
                                <ShareSection wallsData={wallsData} wallDetails={appsMore?.detail} userData={userData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CommonUpgradePop containerId={document.getElementById('snapupUpgradModal')} show={showUpgradeModal} onCloseClick={() => this.setState({ showUpgradeModal: false })} title="Unlock SnapUp" description="Give attendees the power to share their moments directly. Snapup lets event-goers upload photos and videos instantly, keeping the content on-brand and in one place." mediaUrl={`${WASABI_PATH}website/socialwalls/assets/section-library/images/home/new/snapup_video.mp4?v=1`} onUpgradeClick={pricingModal} mediaType="video" backdrop="static" />

            <CommonUpgradePop show={showDownloadModal} onCloseClick={this.closeDownloadModal} title="Download SnapUp Data" description="You can download User details, such as Names, Email addresses, and Image URLs, directly from the Review Hub Collection." mediaUrl={`${WASABI_PATH}react-app/media/icons/color-icons/download.svg`} onUpgradeClick={this.downloadSnapUpData} mediaType="image" btnText="Download" size="md" btnLoading={downloadLoading} />
        </div>
    }
}
const mapStateToProps = (state) => {
    return {
        wallsData: state.analyticwallD.userfeeds,
        snapUpData: state.appsMore.snapUpData,
        appsMore: state.appsMore,
        userData: state.authenticated.userData
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getWidgetData: (wallId) => dispatch(getWidgetWallData(localStorage.getItem('ownerId'), wallId)),
        GET_SNAPUP_DETAILS: () => dispatch(GET_SNAPUP_DETAILS()),
        SNAPUP_UPDATE: (data, callBack) => dispatch(SNAPUP_UPDATE(data, callBack)),
        pricingModal: () => dispatch(togglePlanSection_D(true)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ReviewHub);